/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starts_TodayInputs */

const th_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มวันนี้`)
};

const en_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting today`)
};

const ja_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本日開始`)
};

const zh_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天开始`)
};

const es_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza hoy`)
};

const pt_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa hoje`)
};

const id_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai hari ini`)
};

const fr_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence aujourd’hui`)
};

const tl_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magsisimula ngayon`)
};

const vi_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu hôm nay`)
};

const ko_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘 시작`)
};

const de_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginnt heute`)
};

const ru_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинается сегодня`)
};

const tr_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugün başlıyor`)
};

const it_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia oggi`)
};

const pl_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaczyna się dzisiaj`)
};

const uk_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Починається сьогодні`)
};

const hi_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आज शुरू`)
};

const ar_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يبدأ اليوم`)
};

const ms_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermula hari ini`)
};

const bn_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আজ শুরু`)
};

const zh_tw2_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天開始`)
};

const zh_hk2_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天開始`)
};

const ur_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آج شروع`)
};

const fa_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امروز آغاز می‌شود`)
};

const sw_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaanza leo`)
};

const nl_starts_today = /** @type {(inputs: Starts_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begint vandaag`)
};

/**
* | output |
* | --- |
* | "Starting today" |
*
* @param {Starts_TodayInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const starts_today = /** @type {((inputs?: Starts_TodayInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starts_TodayInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_starts_today(inputs)
	if (locale === "ja") return ja_starts_today(inputs)
	if (locale === "zh") return zh_starts_today(inputs)
	if (locale === "es") return es_starts_today(inputs)
	if (locale === "pt") return pt_starts_today(inputs)
	if (locale === "id") return id_starts_today(inputs)
	if (locale === "fr") return fr_starts_today(inputs)
	if (locale === "tl") return tl_starts_today(inputs)
	if (locale === "vi") return vi_starts_today(inputs)
	if (locale === "ko") return ko_starts_today(inputs)
	if (locale === "de") return de_starts_today(inputs)
	if (locale === "ru") return ru_starts_today(inputs)
	if (locale === "tr") return tr_starts_today(inputs)
	if (locale === "it") return it_starts_today(inputs)
	if (locale === "pl") return pl_starts_today(inputs)
	if (locale === "uk") return uk_starts_today(inputs)
	if (locale === "hi") return hi_starts_today(inputs)
	if (locale === "ar") return ar_starts_today(inputs)
	if (locale === "ms") return ms_starts_today(inputs)
	if (locale === "bn") return bn_starts_today(inputs)
	if (locale === "zh-TW") return zh_tw2_starts_today(inputs)
	if (locale === "zh-HK") return zh_hk2_starts_today(inputs)
	if (locale === "ur") return ur_starts_today(inputs)
	if (locale === "fa") return fa_starts_today(inputs)
	if (locale === "sw") return sw_starts_today(inputs)
	if (locale === "nl") return nl_starts_today(inputs)
	return en_starts_today(inputs)
});